// users
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const RESET_USER_STATE = 'RESET_USER_STATE';
export const SET_ROLE = 'SET_ROLE';
export const SET_STUDENT = 'SET_STUDENT';
export const SET_TEACHER = 'SET_TEACHER';
export const SET_TEACHER_PERMISSIONS = 'SET_TEACHER_PERMISSIONS';
export const SET_USERS_AND_INVITATIONS = 'SET_USERS_AND_INVITATIONS';
export const SET_ZOOM_INFO = 'SET_ZOOM_INFO';
export const SET_GOOGLE_MEET_INFO = 'SET_GOOGLE_MEET_INFO';
export const SET_USER_INFO_PROMISE = 'SET_USER_INFO_PROMISE';
export const SET_PLANS = 'SET_PLANS';
export const SET_COACHING_PROGRAMME = 'SET_COACHING_PROGRAMME';
export const SET_COUPON = 'SET_COUPON';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const SET_LOCAL = 'SET_LOCAL';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_LOCAL_STUDIO_PASSWORD = 'SET_LOCAL_STUDIO_PASSWORD';
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SET_PUNCHES = 'SET_PUNCHES';
export const SET_PURCHASES = 'SET_PURCHASES';
export const SET_SHOW_UPGRADE_MODAL = 'SET_SHOW_UPGRADE_MODAL';

// websocket (dots in the event name come from backend)
export const EVENT_UPDATED = 'EVENT.UPDATED';
export const EVENT_STARTING_SOON = 'EVENT.STARTING.SOON';
export const PAGE_GENERATED = 'PAGE.GENERATED';
export const PODCAST_EPISODE_CONVERTED = 'PODCAST.EPISODE_CONVERTED';
export const SOCKET_ONOPEN = 'SOCKET_ONOPEN';
export const SOCKET_ONCLOSE = 'SOCKET_ONCLOSE';
export const SOCKET_ONERROR = 'SOCKET_ONERROR';
// studios
export const SET_RECENT_STUDIOS = 'SET_RECENT_STUDIOS';
export const SET_CURRENT_STUDIO = 'SET_CURRENT_STUDIO';
export const SET_STUDIO_EVENTS = 'SET_STUDIO_EVENTS';
export const SET_UPCOMING_STUDIO_EVENTS = 'SET_UPCOMING_STUDIO_EVENTS';
export const RESET_STUDIO_STATE = 'RESET_STUDIO_STATE';
export const SET_FAVOURITES = 'SET_FAVOURITES';
export const SET_EVENT_STARTING_SOON = 'SET_EVENT_STARTING_SOON';
export const SET_SINGLE_TRANSLATION = 'SET_SINGLE_TRANSLATION';
export const REMOVE_SINGLE_TRANSLATION = 'REMOVE_SINGLE_TRANSLATION';
export const SET_CURRENT_TRANSLATION_LANG = 'SET_CURRENT_TRANSLATION_LANG';
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
// products
export const SET_PRODUCT = 'SET_PRODUCT';
export const UPDATE_LESSON_QUIZ_STATUS = 'UPDATE_LESSON_QUIZ_STATUS';
export const SET_PRODUCT_MEDIA = 'SET_PRODUCT_MEDIA';
export const APPEND_PRODUCT_MEDIA = 'APPEND_PRODUCT_MEDIA';
export const SET_LESSON_MEDIA = 'SET_LESSON_MEDIA';
export const SET_STUDENT_PLAYLISTS = 'SET_STUDENT_PLAYLISTS';
export const SET_STUDENT_PLAYLIST = 'SET_STUDENT_PLAYLIST';
export const SET_LESSONS_COMPLETE = 'SET_LESSONS_COMPLETE';
export const SET_LESSONS_INCOMPLETE = 'SET_LESSONS_INCOMPLETE';
export const SET_LIKE_STATUS = 'SET_LIKE_STATUS';
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
export const SET_STUDIO_INSTRUCTORS = 'SET_STUDIO_INSTRUCTORS';
export const RESET_PRODUCT_STATE = 'RESET_PRODUCT_STATE';
export const SET_TEACHER_PRODUCTS = 'SET_TEACHER_PRODUCTS';
export const SET_TEACHER_PRODUCT = 'SET_TEACHER_PRODUCT';
export const SET_TEACHER_PRODUCTS_WITH_PRIVATE_SESSIONS =
  'SET_TEACHER_PRODUCTS_WITH_PRIVATE_SESSIONS';
export const SET_TEACHER_COUPONS = 'SET_TEACHER_COUPONS';
export const SET_TEACHER_TAX_RATES = 'SET_TEACHER_TAX_RATES';
export const SET_PRODUCT_TAGS = 'SET_PRODUCT_TAGS';
export const SET_TEACHER_COUPON = 'SET_TEACHER_COUPON';
export const SET_TEACHER_COUPONS_STATS = 'SET_TEACHER_COUPONS_STATS';
export const SET_FILTER = 'SET_FILTER';
export const DELETE_COUPON = 'DELETE_COUPON';
export const SET_PRODUCT_CUSTOMERS = 'SET_PRODUCT_CUSTOMERS';
export const SET_PRODUCT_FORM = 'SET_PRODUCT_FORM';
// globals
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_SCROLLING_STATE = 'SET_SCROLLING_STATE';
export const SET_SELECTED_MENU = 'SET_SELECTED_MENU';
export const SET_IS_MAIN_NAV_OPEN = 'SET_IS_MAIN_NAV_OPEN';
export const SET_IS_STUDIO_MOBILE_PROFILE_MENU_OPEN =
  'SET_IS_STUDIO_MOBILE_PROFILE_MENU_OPEN';
export const SET_IS_DIRTY = 'SET_IS_DIRTY';
export const SET_FORM_SAVE_FUN = 'SET_FORM_SAVE_FUN';
export const SET_STUDIO_URL = 'SET_STUDIO_URL';
export const SET_SHOW_BIO_UPGRADE = 'SET_SHOW_BIO_UPGRADE';
export const SET_AFFILIATE_CODE = 'SET_AFFILIATE_CODE';
export const SET_SHOW_REFRESH_MODAL = 'SET_SHOW_REFRESH_MODAL';
export const SET_SHOW_LOGIN_MODAL = 'SET_SHOW_LOGIN_MODAL';
export const SET_IS_PWA = 'SET_IS_PWA';
export const SET_SHOW_INSTALL_PWA = 'SET_SHOW_INSTALL_PWA';
export const SET_SHOW_COOKIE_NOTICE = 'SET_SHOW_COOKIE_NOTICE';
export const SET_PREVIEW_TEMPLATE = 'SET_PREVIEW_TEMPLATE';
// events
export const SET_EVENT = 'SET_EVENT';
export const SET_EVENT_CANCELLED = 'SET_EVENT_CANCELLED';
export const SET_EVENT_REGISTRATIONS = 'SET_EVENT_REGISTRATIONS';
export const SET_EVENT_CATEGORIES = 'SET_EVENT_CATEGORIES';
export const SET_EVENTS = 'SET_EVENTS';
export const SET_EVENTS_LOADING = 'SET_EVENTS_LOADING';
export const SET_SELECTED_EVENT_TYPE = 'SET_SELECTED_EVENT_TYPE';
export const SET_CURRENT_VIEW_TYPE = 'SET_CURRENT_VIEW_TYPE';
export const SET_REGISTRATION_ATTENDED = 'SET_REGISTRATION_ATTENDED';
export const REMOVE_REGISTRATION_ATTENDED = 'REMOVE_REGISTRATION_ATTENDED';
export const SET_TEACHER_CALENDAR_SELECTED_DATE =
  'SET_TEACHER_CALENDAR_SELECTED_DATE';
// dashboard
export const SET_DASHBOARD = 'SET_DASHBOARD';
// sales
export const SET_SALES_PURCHASES = 'SET_SALES_PURCHASES';
export const SET_SALES_PURCHASES_STATS = 'SET_SALES_PURCHASES_STATS';
export const SET_TIP_JAR_STATS = 'SET_TIP_JAR_STATS';
export const SET_TIPS = 'SET_TIPS';
export const SET_SALES_CUSTOMERS = 'SET_SALES_CUSTOMERS';
export const SET_SALES_CUSTOMERS_STATS = 'SET_SALES_CUSTOMERS_STATS';
export const SET_PAYMENT_PLAN_STATS = 'SET_PAYMENT_PLAN_STATS';
export const SET_CUSTOMER_DETAIL = 'SET_CUSTOMER_DETAIL';
export const SET_CUSTOMER_PUNCHES = 'SET_CUSTOMER_PUNCHES';
export const SET_CUSTOMER_STATS = 'SET_CUSTOMER_STATS';
// media library
export const SET_MEDIA = 'SET_MEDIA';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_INSTRUCTORS = 'SET_INSTRUCTORS';
// reports
export const SET_USER_ACTIVITY = 'SET_USER_ACTIVITY';
export const SET_USER_ACTIVITY_STATS = 'SET_USER_ACTIVITY_STATS';
export const SET_REPORTS_SALES = 'SET_REPORTS_SALES';
export const SET_REPORTS_SALES_STATS = 'SET_REPORTS_SALES_STATS';
// settings
export const SET_CURRENCIES = 'SET_CURRENCIES';
export const SET_DOMAIN = 'SET_DOMAIN';
export const SET_PAGES_DOMAIN = 'SET_PAGES_DOMAIN';
export const SET_USE_CUSTOM_DOMAIN_URL = 'SET_USE_CUSTOM_DOMAIN_URL';
export const SET_CODE_EMBED = 'SET_CODE_EMBED';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const SET_EMAIL_PROVIDER = 'SET_EMAIL_PROVIDER';
export const SET_FLODESK_SEGMENTS = 'SET_FLODESK_SEGMENTS';
export const SET_MAIL_CHIMP_LISTS = 'SET_MAIL_CHIMP_LISTS';
export const SET_CONVERT_KIT_TAGS = 'SET_CONVERT_KIT_TAGS';
export const SET_FB_PIXEL = 'SET_FB_PIXEL';
export const SET_GOOGLE_ANALYTICS_CODE = 'SET_GOOGLE_ANALYTICS_CODE';
export const SET_ZOOM = 'SET_ZOOM';
export const SET_WAIVER = 'SET_WAIVER';
export const SET_CALENDLY = 'SET_CALENDLY';
export const SET_CALENDLY_V2 = 'SET_CALENDLY_V2';
export const SET_FLODESK = 'SET_FLODESK';
export const SET_INTEGRATIONS_STATUS = 'SET_INTEGRATIONS_STATUS';
export const SET_TWILIO = 'SET_TWILIO';
export const SET_ACUITY = 'SET_ACUITY';
export const SET_GOOGLE_CALENDARS = 'SET_GOOGLE_CALENDARS';
export const SET_GOOGLE_MAILS = 'SET_GOOGLE_MAILS';
export const SET_SMTP = 'SET_SMTP';
export const SET_INVOICE_HISTORY = 'SET_INVOICE_HISTORY';
export const SET_STREAMING_PROPS = 'SET_STREAMING_PROPS';
export const SET_TIP_JAR_INTEGRATION = 'SET_TIP_JAR_INTEGRATION';
export const SET_BIO_TEMPLATES = 'SET_BIO_TEMPLATES';
export const SET_MARVELOUS_BIO = 'SET_MARVELOUS_BIO';
export const ADD_MARVELOUS_BIO_LINK = 'ADD_MARVELOUS_BIO_LINK';
export const UPDATE_MARVELOUS_BIO_LINK = 'UPDATE_MARVELOUS_BIO_LINK';
export const REMOVE_MARVELOUS_BIO_LINK = 'REMOVE_MARVELOUS_BIO_LINK';
export const RESET_SETTING_STATE = 'RESET_SETTING_STATE';
export const SET_GOOGLE_MEETS = 'SET_GOOGLE_MEETS';
// table factory
export const SET_REQUEST_DISPATCH = 'SET_REQUEST_DISPATCH';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_PER_PAGE = 'SET_PER_PAGE';
export const SET_PER_PAGE_FIXED = 'SET_PER_PAGE_FIXED';
export const SET_ALL_PAGES = 'SET_ALL_PAGES';
export const SET_RES = 'SET_RES';
export const SET_ORDERING = 'SET_ORDERING';
export const SET_ORDERING_DIRECTION = 'SET_ORDERING_DIRECTION';
export const SET_QUERY = 'SET_QUERY';
export const SET_CANCEL_SOURCE = 'SET_CANCEL_SOURCE';
// community
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_STUDIO_NOTIFICATIONS = 'SET_STUDIO_NOTIFICATIONS';
export const SET_NEXT_NOTIFICATIONS = 'SET_NEXT_NOTIFICATIONS';
export const SET_NEXT_STUDIO_NOTIFICATIONS = 'SET_NEXT_STUDIO_NOTIFICATIONS';
export const SET_NOTIFICATIONS_OFFSET = 'SET_NOTIFICATIONS_OFFSET';
export const SET_STUDIO_NOTIFICATIONS_OFFSET =
  'SET_STUDIO_NOTIFICATIONS_OFFSET';
export const SET_CAN_LOAD_MORE_NOTIFICATIONS =
  'SET_CAN_LOAD_MORE_NOTIFICATIONS';
export const SET_CAN_LOAD_MORE_STUDIO_NOTIFICATIONS =
  'SET_CAN_LOAD_MORE_STUDIO_NOTIFICATIONS';
export const SET_NUMBER_OF_NOTIFICATIONS = 'SET_NUMBER_OF_NOTIFICATIONS';
export const SET_NUMBER_OF_STUDIO_NOTIFICATIONS =
  'SET_NUMBER_OF_STUDIO_NOTIFICATIONS';
export const SET_NUMBER_OF_CHAT_NOTIFICATIONS =
  'SET_NUMBER_OF_CHAT_NOTIFICATIONS';
export const SET_NUMBER_OF_STUDIO_CHAT_NOTIFICATIONS =
  'SET_NUMBER_OF_STUDIO_CHAT_NOTIFICATIONS';
export const SET_NOTIFICATIONS_TOKEN = 'SET_NOTIFICATIONS_TOKEN';
export const SET_STUDIO_NOTIFICATIONS_TOKEN = 'SET_STUDIO_NOTIFICATIONS_TOKEN';
export const SET_CAN_LOAD_MORE_GIPHY = 'SET_CAN_LOAD_MORE_GIPHY';
export const SET_INTERACT_AS_STUDIO = 'SET_INTERACT_AS_STUDIO';
export const SET_TEACHER_GROUPS = 'SET_TEACHER_GROUPS';
export const SET_STUDIO_GROUPS = 'SET_STUDIO_GROUPS';
export const SET_STUDIO_GROUP = 'SET_STUDIO_GROUP';
export const SET_COMMENTS = 'SET_COMMENTS';
export const SET_STUDIO_MEMBERS = 'SET_STUDIO_MEMBERS';
export const SET_CHAT_CLIENT = 'SET_CHAT_CLIENT';
export const COMMENT_ADDED = 'COMMENT_ADDED';
export const COMMENT_EDITED = 'COMMENT_EDITED';
export const COMMENT_DELETED = 'COMMENT_DELETED';
// quizzes
export const SET_QUIZZES = 'SET_QUIZZES';
export const SET_QUIZ = 'SET_QUIZ';
export const SET_QUIZ_QUESTIONS = 'SET_QUIZ_QUESTIONS';
export const SET_QUIZ_ANSWERS = 'SET_QUIZ_ANSWERS';
// affiliates
export const SET_AFFILIATE_COUPON = 'SET_AFFILIATE_COUPON';
// headers
export const SET_RELEASE_VERSION = 'SET_RELEASE_VERSION';
// gifts
export const SET_GIFTS_PURCHASES = 'SET_GIFTS_PURCHASES';
export const SET_GIFTS_PURCHASES_STATS = 'SET_GIFTS_PURCHASES_STATS';
// pages
export const SET_PAGE = 'SET_PAGE';
// podcasts
export const SET_PODCASTS = 'SET_PODCASTS';
// marketing
export const SET_MEETING_TYPE_CATEGORIES = 'SET_MEETING_TYPE_CATEGORIES';
